export enum DispatchEvent {
  cancel = "canceled",
  close = "closed",
}

export enum Action {
  reopen = "reopen",
}

export enum EventUpdateType {
  add = "add",
  remove = "remove",
}

export type UpdateEventParams = {
  caseId: string;
  type?: EventUpdateType;
  event: DispatchEvent | Action;
};
